import { Outlet, useParams } from "react-router-dom"
import QueryWrapper from "common/components/QueryWrapper"
import { ScreenLayout } from "common/layouts/ScreenLayout"
import { useGetGameQuery } from "quiz/api/games.endpoints"
import { withDebug } from "common/debug/components/withDebug"

function QuizScreenShellWithGameWrapperComponent() {
  const { gameId } = useParams()
  const getGameQuery = useGetGameQuery(gameId!)

  return (
    <QueryWrapper query={getGameQuery}>
      {(game) => (
        <ScreenLayout theme={game.quizSnapshot}>
          <Outlet />
        </ScreenLayout>
      )}
    </QueryWrapper>
  )
}

export const QuizScreenShellWithGameWrapper = withDebug(
  QuizScreenShellWithGameWrapperComponent
)
